import { FC, Fragment } from 'react';

import { Link } from '@dbt-labs/sourdough';

import { useLinkToExplorer } from '@/hooks/links';
import { useUrlProjectParams } from '@/hooks/params';

interface TagLinkProps {
  tag: string;
}

const TagLink: FC<TagLinkProps> = ({ tag }) => {
  // TODO: should this go to the search results page with the _filter_ `tag:?`
  const getSelectorLink = useLinkToExplorer('projectLineage');
  const projectScope = useUrlProjectParams();

  return (
    <Link
      isInternal
      key={tag}
      to={getSelectorLink({ ...projectScope, selector: `tag:${tag}` })}
    >
      {tag}
    </Link>
  );
};

interface TagLinksProps {
  tags: string[] | null;
}

export const TagLinks: FC<TagLinksProps> = ({ tags }) => {
  if (!tags?.length) return null;
  return (
    <span className="space-x-1">
      {tags.map((tag, index) => (
        <Fragment key={`${tag}-${index}`}>
          <TagLink key={tag} tag={tag} />
          {index < tags.length - 1 && ','}
        </Fragment>
      ))}
    </span>
  );
};
